export const categories = [
  {
    id: "xiangjiao",
    name: "香蕉视频",
    slug: "xiangjiao",
    description: "香蕉视频平台汇聚海量高清影视资源，涵盖最新电视剧、热门电影、综艺节目、动漫番剧等丰富内容。",
    icon: "ri-movie-2-line",
    color: "from-yellow-400 to-yellow-500",
    bgColor: "bg-yellow-50",
    textColor: "text-yellow-700",
    borderColor: "border-yellow-200",
    videoCount: 1280,
    featured: true,
  },
  {
    id: "mitao",
    name: "蜜桃视频",
    slug: "mitao",
    description: "蜜桃视频为您提供甜蜜观影体验，高清画质不卡顿，每日更新最新资源，让追剧成为一种享受。",
    icon: "ri-heart-line",
    color: "from-pink-400 to-rose-500",
    bgColor: "bg-pink-50",
    textColor: "text-pink-700",
    borderColor: "border-pink-200",
    videoCount: 960,
    featured: true,
  },
  {
    id: "xigua",
    name: "西瓜视频",
    slug: "xigua",
    description: "西瓜视频清新一夏，海量免费全集在线观看，支持手机电脑多端同步，随时随地畅享精彩内容。",
    icon: "ri-water-flash-line",
    color: "from-green-400 to-emerald-500",
    bgColor: "bg-green-50",
    textColor: "text-green-700",
    borderColor: "border-green-200",
    videoCount: 1560,
    featured: true,
  },
  {
    id: "yinghua",
    name: "樱花视频",
    slug: "yinghua",
    description: "樱花视频浪漫唯美，日韩剧集专區，动漫新番速递，为您呈现最精致的视觉盛宴。",
    icon: "ri-flower-line",
    color: "from-pink-300 to-purple-400",
    bgColor: "bg-purple-50",
    textColor: "text-purple-700",
    borderColor: "border-purple-200",
    videoCount: 840,
    featured: true,
  },
  {
    id: "tangdou",
    name: "糖豆视频",
    slug: "tangdou",
    description: "糖豆视频甜蜜来袭，精选热门短视频、搞笑段子、生活妙招，每天都有新鲜有趣的内容等您发现。",
    icon: "ri-cake-3-line",
    color: "from-orange-400 to-amber-500",
    bgColor: "bg-orange-50",
    textColor: "text-orange-700",
    borderColor: "border-orange-200",
    videoCount: 2100,
    featured: false,
  },
  {
    id: "yingtao",
    name: "樱桃视频",
    slug: "yingtao",
    description: "樱桃视频红润饱满，主打精品短剧、独家自制内容，为您打造专属的私人影院体验。",
    icon: "ri-git-repository-private-line",
    color: "from-red-400 to-rose-600",
    bgColor: "bg-red-50",
    textColor: "text-red-700",
    borderColor: "border-red-200",
    videoCount: 670,
    featured: false,
  },
  {
    id: "mogu",
    name: "蘑菇视频",
    slug: "mogu",
    description: "蘑菇视频萌趣可爱，专注儿童动画、亲子教育内容，给家庭带来欢乐温馨的观影时光。",
    icon: "ri-plant-line",
    color: "from-teal-400 to-cyan-500",
    bgColor: "bg-teal-50",
    textColor: "text-teal-700",
    borderColor: "border-teal-200",
    videoCount: 530,
    featured: false,
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});